import React from 'react'
import Link from 'gatsby-link'

import phone from '../images/phone.jpg'
import matrix from '../images/matrix.jpg'
import whitepaper from '../images/whitepaper.jpg'

class Main extends React.Component {
  render() {

    let close = <div className="close" onClick={() => {this.props.onCloseArticle()}}></div>

    return (
      <div id="main" style={this.props.timeout ? {display: 'flex'} : {display: 'none'}}>

        <article id="intro" className={`${this.props.article === 'intro' ? 'active' : ''} ${this.props.articleTimeout ? 'timeout' : ''}`} style={{display:'none'}}>
          <h2 className="major">The Problem</h2>
          <span className="image main"><img src={phone} alt="" /></span>
          <h3>Everybody wants a trading bot.</h3>
          <p>As adoption of blockchain technology grows, so does the underlying cryptocurrency market fueled by speculative investment. Many former Wall Street professionals, some with backgrounds working at hedge funds or quantitative trading shops, have embraced cryptocurrency trading. As is the case in traditional equity markets, the most successful cryptocurrency traders are becoming increasingly reliant on automated trading systems&mdash;or more-commonly referred to as "trading bots"&mdash;which execute trades according to algorithms.</p>
          <h3>Very few people can actually build one.</h3>
          <p>While the existence of algorithmic trading in cryptocurrency markets has been far from secret, what remains shrouded in mystery is how exactly such algorithms work, and perhaps more elusive, is how exactly they are engineered. Developers of successful trading algorithms are notoriously reluctant to share their work, if at all. Those that do make their work available do so at a steep price; and potential users are wary to the glaring shortcomings such as reliance on a single point of contact for ongoing development, lack of control over algorithm parameters, risk management, and unclear profitability.</p>
          <h4>Read <a href={"https://aiex.network/files/aiex_whitepaper_en.pdf"} target={"_blank"}>our whitepaper</a> to learn more.</h4>
          {close}
        </article>

        <article id="work" className={`${this.props.article === 'work' ? 'active' : ''} ${this.props.articleTimeout ? 'timeout' : ''}`} style={{display:'none'}}>
          <h2 className="major">Our Solution</h2>
          <span className="image main"><img src={matrix} alt="" /></span>
          <h3>Introducing, AiEX&mdash;the platform for developing, testing, and deploying automated trading algorithms for any cryptocurrency on any exchange.</h3>
          <p><strong>AiEX</strong> eliminates the complex barriers to building and profiting from the most elusive & sought-after trading tool. <strong>AiEX</strong> combines comprehensive time-series data, a robust trading framework, cutting-edge machine-learning & portfolio analytics with a user-experience friendly for both novices & seasoned veterans alike. Users are empowered to <em>"Build-Your-Own-Bot"</em>, either for public or private use&mdash;<em>no programming experience necessary</em>. Private investors are incentivized to deploy capital behind the best algorithms via licensing & sale contracts. By creating a decentralized marketplace of knowledge, <strong>AiEX</strong> transforms learning & development into a true meritocracy where anyone can create a good algorithm and be rewarded for it.</p>
          <h4>Read <a href={"https://aiex.network/files/aiex_whitepaper_en.pdf"} target={"_blank"}>our whitepaper</a> to learn more.</h4>
          {close}
        </article>

        <article id="about" className={`${this.props.article === 'about' ? 'active' : ''} ${this.props.articleTimeout ? 'timeout' : ''}`} style={{display:'none'}}>
          <h2 className="major">Whitepaper</h2>
          <span className="image main"><img src={whitepaper} alt="" /></span>
          <h3><a href={"https://aiex.network/files/aiex_whitepaper_en.pdf"} target={"_blank"}>English</a></h3>
          <h3>Chinese &ndash; Coming Soon!</h3>
          {close}
        </article>

        <article id="contact" className={`${this.props.article === 'contact' ? 'active' : ''} ${this.props.articleTimeout ? 'timeout' : ''}`} style={{display:'none'}}>
          <h2 className="major">Sign up for Beta</h2>
          <form method="post" name="contact" data-netlify="true" data-netlify-honeypot="bot-field">
            <p hidden>
              <label>
                Don’t fill this out: <input name="bot-field" />
              </label>
            </p>
            <div className="field half first">
              <label htmlFor="name">Name</label>
              <input type="text" name="name" id="name" onChange={this.handleChange}/>
            </div>
            <div className="field half">
              <label htmlFor="email">Email</label>
              <input type="text" name="email" id="email" onChange={this.handleChange}/>
            </div>
            <ul className="actions">
              <li><input type="submit" value="Submit" className="special" /></li>
            </ul>
          </form>
          <ul className="icons">
            <li><a href="#" className="icon fa-twitter"><span className="label">Twitter</span></a></li>
            <li><a href="#" className="icon fa-github"><span className="label">GitHub</span></a></li>
            <li><a href="#" className="icon fa-telegram"><span className="label">Telegram</span></a></li>
          </ul>
          {close}
        </article>

      </div>
    )
  }
}

Main.propTypes = {
  route: React.PropTypes.object,
  article: React.PropTypes.string,
  articleTimeout: React.PropTypes.bool,
  onCloseArticle: React.PropTypes.func,
  timeout: React.PropTypes.bool
}

export default Main


// WEBPACK FOOTER //
// ./src/components/Main.js